import React from "react";

export const SeatCalendarContext = React.createContext({date: new Date()});